import { initDuerSDK, getDuerSDK } from '@/utils/duerSDK';
import Vue from 'vue'

const vm = new Vue();
const callVue = new Vue();
const makingCall = new Vue();

let duerRtc = null;
let duerRtcSdk = null;
let duerRtcSdkState = null;
let audio = new Audio();
audio.src = 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-9/1662024495462/ring_new.mp3';
let callInfo = {};
let layout = [];

export const initializeDuerSDK = async () => {
  try {
    duerRtcSdk = await initDuerSDK();
    duerRtcSdk = await getDuerSDK();
    callInfo = {
      mute: false,
      mode: duerRtcSdk.CallMode.AUDIO_VIDEO,
    };
  } catch (error) {
    console.error('DUER SDK 初始化失败:', error);
    throw error;
  }
};

export const setLayouts = (layouts) => {
  if (!layouts) {
    return;
  }
  const audioLocal = document.getElementById('audio-local');
  const videoLocal = document.getElementById('video-local');
  const audioPeer = document.getElementById('audio-peer');
  const videoPeer = document.getElementById('video-peer');
  const [layoutLocal, layoutPeer] = layouts;
  if (layoutLocal.videoTrack) {
    callVue.$showVideoLocalDialog();
    callVue.$hideLocalViewDialog();
    callVue.$hideAudioTipWrapDialog();
    const stream = new MediaStream();
    stream.addTrack(layoutLocal.videoTrack);
    videoLocal.srcObject = stream;
  } else {
    callVue.$hideVideoLocalDialog();
    callVue.$showLocalViewDialog();
    callVue.$showAudioTipWrapDialog();
  }
  if (layoutLocal.audioTrack && !layoutLocal.isLocal) {
    const stream = new MediaStream();
    stream.addTrack(layoutLocal.audioTrack);
    audioLocal.srcObject = stream;
  }
  if (layoutPeer.videoTrack) {
    callVue.$showVideoPeerDialog();
    callVue.$hideAudioTipWrapDialog();
    callVue.$hidePeerViewDialog();
    const stream = new MediaStream();
    stream.addTrack(layoutPeer.videoTrack);
    videoPeer.srcObject = stream;
  } else {
    callVue.$hideVideoPeerDialog()
    callVue.$showAudioTipWrapDialog();
    callVue.$showPeerViewDialog();
  }
  if (layoutPeer.audioTrack) {
    const stream = new MediaStream();
    stream.addTrack(layoutPeer.audioTrack);
    audioPeer.srcObject = stream;
  }
};

//断开连接
export const checkLoginOut = () => {
  if (duerRtc) {
    duerRtc.logout();
  }
};

//建立连接
export const checkLoginForm = (uid,token) => {
  duerRtc = new duerRtcSdk.RtcContext(
    {
      onAuthStatusChanged: (auth) => {
        if (auth.success) {
            // 开启自动入席离席
          duerRtc.enableCustomer(true);
        } else {
          switch (auth.code) {
            case duerRtcSdk.AuthCode.PARAM_ERROR:
            case duerRtcSdk.AuthCode.APPID_INVALID: {
              console.log('联调阶段遇到错误');
              break;
            }
            case duerRtcSdk.AuthCode.TOKEN_INVALID:
            case duerRtcSdk.AuthCode.TOKEN_EXPIRED: {
              break;
            }
            case duerRtcSdk.AuthCode.NO_ERROR:
            case duerRtcSdk.AuthCode.OTHER_DEVICE_LOGIN: {
              break;
            }
          }
        }
      },
    },
    true
  );
  duerRtc.setCallListener({
    //收到来电时回调
    onIncomingCall: (intent) => {
      const serviceInfo =
        (intent.serviceInfo && JSON.parse(intent.serviceInfo)) || {};
      intent.serviceInfo = serviceInfo;
      Object.assign(callInfo, intent);
      incomingViewShow();
      console.log('onIncomingCall', intent);
    },
    onAddConfereeStateChanged: (state) => {
      console.log('onAddConfereeStateChanged', state);
    },
    onCallReplaced: (replaced) => {
      console.log('onCallReplaced', replaced);
    },
    //通话状态改变时回调
    onCallStateChanged: (stateInfo) => {
        //stateInfo.state取值:1空闲  2客户端向服务端发送offer后的状态  3客户端向服务端发送offer后,并收到服务端回复trying时的状态  4主叫方呼出  5振铃  6呼叫已接通  7呼叫已断开
      if (stateInfo.state === duerRtcSdk.CallState.RINGBACK) {
        // 被叫开始响铃
        console.log('被叫开始响铃');
        ringViewShow();
      } else if (stateInfo.state === duerRtcSdk.CallState.DISCONNECTED) {
        // 通话已经断开
        console.log('通话已经断开');
        freeCallView();
        if (stateInfo.reason === duerRtcSdk.CallReason.TIMEOUT) {
            // 呼叫超时
          console.log('呼叫超时');
        }
      } else if (stateInfo.state === duerRtcSdk.CallState.CONNECTED) {
        // 通话被正常接听
        console.log('通话被正常接听');
        callViewShow();
      }
      console.log('onCallStateChanged', stateInfo);
    },
    onConfereeLayout: (layouts) => {
      setLayouts(layouts);
      console.log('onConfereeLayout', layouts);
    },
    onRecordStateChanged: (recordStateInfo) => {
      console.log('onRecordStateChanged', recordStateInfo);
    },
  });
  // 长连接状态监听器
  duerRtc.setConnectListener({
    onConnectionChanged: (conn) => {
      if (conn === duerRtcSdk.Connection.CONNECTING) {
        console.log('正在连接');
      } else if (conn === duerRtcSdk.Connection.CONNECTED) {
        console.log('已连接');
        duerRtcSdkState = '已连接';
        // 显示成功消息
      } else if (conn === duerRtcSdk.Connection.DISCONNECTED) {
        console.log('连接已断开');
        // 显示错误消息
      }
    },
  });
        /**
       * 设置媒体设备监听器，获得摄像头与麦克风状态
       * @param device 设备类型： 0 音频采集设备 1 视频采集设备
       * @param state 设备状态：0 已打开 1 已关闭 2 打开过程遇到错误
       * @param error 错误
       */
  duerRtc.setMediaDeviceListener({
    // 麦克风/摄像头状态
    onMediaDeviceStateChanged: (device, state, error) => {
      console.log('onMediaDeviceStateChanged', device, state, error);
    },
  });
  rtcConnect(uid,token);
};

// 建立长连接
export const rtcConnect = (uid,token) => {
  const uri = new duerRtcSdk.CallUri(uid, 'm6eb98d2');
  const loginParams = {
    uri: uri,
    uid: uid,
    appId: 'm6eb98d2',
    appName: '小度',
    token:
    token,
  };
  duerRtc.login(loginParams);
};

 // 来电接听
export const answerCall = (mode) => {
  duerRtc.answerCall(callInfo.index, mode, false);
  callInfo.callMode = mode;
};

// 拒接来电
export const rejectCall = () => {
  duerRtc.rejectIncomingCall(callInfo.index, 'REJECT_CALL_USER_REASON');
};

//呼叫
export const makeCall = (
  appId,
  uid,
  callMode,
  callerRole = duerRtcSdk.CallerRole.CALL_CENTER
) => {
  const calleeUri = new duerRtcSdk.CallUri(uid, appId);
  let intent = duerRtcSdk.MakeCallIntent(
    calleeUri,
    duerRtcSdk.CallMode.AUDIO_VIDEO
  );
  callMode && (intent.callMode = callMode);
  callerRole && (intent.callerRole = callerRole);
  callInfo.callMode = callMode;
  const result = duerRtc.makeCall(intent);
  console.info('makeCall action', intent, result);
  if (duerRtcSdk.CallReason.NORMAL == result) {
    console.log('呼出成功');
  } else if (
    duerRtcSdk.CallReason.ALREADY_IN_CALL == result ||
    duerRtcSdk.CallReason.EXCEPTION_INPUT_ILLEGAL == result
  ) {
    console.error('makeCall reason', duerRtcSdk.CallReasonMap.get(result));
  } else {
    console.warn('makeCall res', result);
  }
};

//去电响铃页面展示
export const ringViewShow = () => {
  audio.play();
  //callInfo.callInfoName = callInfo.name || 'Unknown Caller';
  if (callInfo.callMode == duerRtcSdk.CallMode.AUDIO_VIDEO) {
    makingCall.$getCallInfo(callInfo.name, '语音通话', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png')
  } else if (callInfo.callMode == duerRtcSdk.CallMode.AUDIO_ONLY) {
    makingCall.$getCallInfo(callInfo.name, '视频通话', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png')
  }
  makingCall.$showMakingCallDialog();
};

// 通话正常接听
export const callViewShow = () => {
  makingCall.$hideMakingCallDialog();
  audio.pause();
  vm.$hideIncomingCallDialog();
  if (callInfo.mute) {
    callVue.$getMute('已静音','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
  } else {
    callVue.$getMute('静音','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
  }
  if (callInfo.callMode == duerRtcSdk.CallMode.AUDIO_VIDEO) {
    callVue.$getCall('语音通话','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
    callVue.$hideAudioTipWrapDialog();
  } else if (callInfo.callMode === duerRtcSdk.CallMode.AUDIO_ONLY) {
    callVue.$getCall('视频通话','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
    callVue.$showAudioTipWrapDialog();
  }
  callVue.$showCallViewDialog();
};
//呼叫
export const checkCall = (appId,uid,callMode) =>{
  console.log(duerRtcSdkState);
  if(duerRtcSdkState!==null){
    makeCall(appId,uid,callMode);
  }
}
// 改变通话模式 type 1去电  2通话中
export const changeMode = () =>{
    const mode = callInfo.callMode == duerRtcSdk.CallMode.AUDIO_VIDEO
    ? duerRtcSdk.CallMode.AUDIO_ONLY
    : duerRtcSdk.CallMode.AUDIO_VIDEO;
    console.log(mode, callInfo.callMode);
    if (mode == duerRtcSdk.CallMode.AUDIO_VIDEO) {
      makingCall.$getCallInfo(callInfo.name, '语音通话', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png')
        //$('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        //$('.v-mode').text('语音通话');
        //$('.audio-tip-wrap').hide();
    } else if (mode == duerRtcSdk.CallMode.AUDIO_ONLY) {
      makingCall.$getCallInfo(callInfo.name, '视频通话', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png')
        //$('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        //$('.v-mode').text('视频通话');
        //$('.audio-tip-wrap').show();
    }
    duerRtc.changeCallMode(mode);
    callInfo.callMode = mode;
};

// 静音状态切换
export const changeMute = () => {
  if (callInfo.mute) {
    callVue.$getMute('静音','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
  } else {
    callVue.$getMute('已静音','https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
  }

  callInfo.mute = !callInfo.mute;
  duerRtc.muteAudio(callInfo.mute);
};

// 挂断通话
export const dropCall = () => {
  duerRtc.dropCall('DROP_CALL_USER_REASON');
};

// 收到来电
export const incomingViewShow = () => {
    audio.loop = true;
  /* 音频可以播放；如果权限允许则播放 */
  audio.play();
  vm.$showIncomingCallDialog();
};

//空闲状态
export const freeCallView = () => {
  audio.pause();
  vm.$hideIncomingCallDialog();
  callVue.$hideCallViewDialog();
  makingCall.$hideMakingCallDialog();
  Object.assign(callInfo, {
    mute: false,
  });
};